import { createSlice } from "@reduxjs/toolkit";

import { CaregiverState } from "./caregiver-types";

export const initialState = { filters: [], searchText: "" } as CaregiverState;

const caregiverSlice = createSlice({
  name: "caregiver",
  initialState,
  reducers: {
    updateSearchText(state, action) {
      state.searchText = action.payload;
    },
    clearSearchText(state) {
      state.searchText = "";
    },
    updateFilters(state, action) {
      state.filters = action.payload;
    },
    clearFilters(state) {
      state.filters = [];
    },
  },
});

export const caregiverReducer = caregiverSlice.reducer;

export const useCaregiverActions = () => {
  return caregiverSlice.actions;
};
